<template>
    <div class="navigation am-cf">
        <div v-for="(item,index) in list" :key="index"
             :class="($route.params.portId+'').substring(0,6)==item.type_id||$route.name=='index'&&index==0?'item active':'item'"
             :style="'width:'+100/list.length+'%'">
            <div class="name am-text-truncate">
                <router-link v-if="item.type_id=='index'" to="/">
                    {{item.menu_name}}
                </router-link>
                <a v-else-if="item.type_id=='other'" :href="item.menu_addr" target="_blank">
                    {{item.menu_name}}
                </a>
                <router-link v-else :to="'/list/'+item.type_id">
                    {{item.menu_name}}
                </router-link>
            </div>
            <div class="item-sub" v-if="item.child.length>0" :ref="'subMenu'+index">
                <ul>
                    <li class="am-text-truncate" v-for="(item,index) in item.child" :key="index">
                        <router-link v-if="item.type_id=='index'" to="/">
                            {{item.menu_name}}
                        </router-link>
                        <a v-else-if="item.type_id=='other'" :href="item.menu_addr" target="_blank">
                            {{item.menu_name}}
                        </a>
                        <router-link v-else :to="'/list/'+item.type_id">
                            {{item.menu_name}}
                        </router-link>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        getMenuMain
    } from '@/api/base'
    export default {
        data() {
            return {
                list: [],
            }
        },
        created() {
            getMenuMain().then(result => {
                this.list = result
            })
        }
    }
</script>

<style lang="scss">
    .navigation {
      background-color: $primary;
        position: relative;
        z-index: 999;
        box-sizing: border;
        background-repeat: no-repeat;
        background-position: center;

        .item {
            float: left;
            position: relative;

            &:hover {
                .name {}
                .item-sub {
                    display: block;
                }
            }

            .name {
                font-size: 14px;
                  height: 40px;
                text-align: center;
            line-height: 40px;
            color: white;
                a {
                    display: block
                }
            }

            .item-sub {
                background-color: darken($color: $primary, $amount: 4%) ;

                display: none;
                z-index: 99;
                width: 100%;
                position: absolute;
                text-align: center;
                padding: 8px 0;
                li {
                    padding: 6px 0;
                    font-size: 14px;
                    color: lighten($color: $primary, $amount: 30%);
                    font-weight: normal;
                    text-align: center;
                    &:hover {
                        color: white;
                        text-decoration: underline;
                    }
                }
            }
        }
    }
</style>